import DefaultRenderer from './default';
import gsap from 'gsap';
import Swiper from 'swiper';
import SplitText from '../../util/SplitText.min.js';

class about extends DefaultRenderer {
	onEnter() {
		super.onEnter();
		gsap.registerPlugin(SplitText);

		// Word Split
		let aboutWords = ['Simplicity', 'Speed', 'Sustainability', 'Satisfaction'];

		let wordIndex = 0;
		let duration = 3;
		let currentWord = document.getElementById('current-word');

		let wordLoop = setInterval(() => {
			gsap.to(currentWord, {
				duration: 0.7,
				opacity: 0,
				ease: 'power4.out',
				onComplete: () => {
					currentWord.innerHTML = aboutWords[wordIndex];
					gsap.to(currentWord, {
						duration: 1,
						opacity: 1,
						ease: 'power4.out',
					});
				},
			});
			if (wordIndex == aboutWords.length - 1) {
				wordIndex = 0;
			} else {
				wordIndex++;
			}
		}, duration * 1000);
		setTimeout(() => {
			wordLoop;
		}, 1000);

		// History slider
		let historyItems = document.getElementsByClassName('history-item'),
			description = document.querySelector('#description-wrapper p'),
			historyPrev = document.getElementById('chart-prev'),
			historyNext = document.getElementById('chart-next'),
			chart = document.getElementById('chart'),
			slideIndex = 0,
			isAnimating = false;

		// -- Init Values
		let initYear = new SplitText(document.querySelector('#year-wrapper .year'), { type: 'chars' });
		gsap.set(initYear.chars, { y: 0 });

		function goToHistoryItem(index) {
			// TODO Try to check if gsap is tweening with native methods
			if (isAnimating) return;
			/* History Description Animation */
			gsap.to(description, {
				duration: 0.6,
				autoAlpha: 0,
				y: 10,
				ease: 'power4.inOut',
				onStart: () => {
					isAnimating = true;
				},
				onComplete: () => {
					description.innerHTML = historyItems[index].innerHTML;
					gsap.to(description, {
						duration: 1,
						autoAlpha: 1,
						y: 0,
						ease: 'power4.out',
					});
				},
			});

			// Year Animation
			var currentYear = document.querySelectorAll('#year-wrapper .year div');
			var newYear = document.createElement('h4');
			newYear.className = 'new-year';
			newYear.textContent = historyItems[index].dataset.year;

			var valuesChars = new SplitText(newYear, { type: 'chars' }).chars;

			gsap.set(newYear, {
				position: 'absolute',
				top: 0,
				left: 0,
			});

			gsap.set(valuesChars, {
				yPercent: 100,
				opacity: 0,
			});

			gsap.to(currentYear, {
				duration: 1,
				opacity: 0,
				yPercent: -100,
				ease: 'expo.out',
				stagger: 0.05,
			});

			gsap.to(valuesChars, {
				duration: 1,
				yPercent: 0,
				opacity: 1,
				ease: 'expo.out',
				stagger: 0.05,
				onComplete: () => {
					gsap.set(newYear, {
						position: 'relative',
					});
					isAnimating = false;

					document
						.querySelector('#year-wrapper .year')
						.parentNode.removeChild(document.querySelector('#year-wrapper .year'));
					newYear.classList.remove('new-year');
					newYear.classList.add('year');
				},
			});

			document.querySelector('#year-wrapper').appendChild(newYear);
			let historyTimelineItem = historyTimeline.querySelector(
				'.history-timeline-item[data-year="' + historyItems[index].dataset.year + '"]',
			);
			activateHistoryItem(historyTimelineItem, index);

			/* Change the nav buttons disabled state with the history index context */
			switch (true) {
				case index > 0 && index < historyItems.length - 1:
					historyPrev.classList.remove('disabled');
					if (historyNext.classList.contains('disabled')) {
						historyNext.classList.remove('disabled');
					}
					break;
				case index == 0:
					historyPrev.classList.add('disabled');
					break;
				case index == historyItems.length - 1:
					historyNext.classList.add('disabled');
					break;
				default:
					break;
			}

			/* Change Graph Percentage */
			let slidePercentage = ((index + 1) * 100) / historyItems.length;
			chart.dataset.percentage = Math.round(slidePercentage * 100) / 100;
		}

		/* Prev/Next listeners */
		historyPrev.addEventListener('click', function() {
			goToHistoryItem((slideIndex -= 1));
			if (slideIndex == 0) {
				return;
			}
		});

		historyNext.addEventListener('click', function() {
			goToHistoryItem((slideIndex += 1));
			if (slideIndex == historyItems.length - 1) {
				return;
			}
		});

		// History Timeline
		let historyTimeline = document.getElementById('historyTimeline'),
			historyTimelineItems = historyTimeline.getElementsByClassName('history-timeline-item');

		function activateHistoryItem(item, index) {
			// Remove all other active classes
			for (let index = 0; index < historyTimelineItems.length; index++) {
				const historyItem = historyTimelineItems[index];
				if (historyItem !== item && historyItem.classList.contains('active')) {
					historyItem.classList.remove('active');
				}
			}
			// add active class
			item.classList.add('active');
			// Set slide index
			slideIndex = index;

			// Move active red dot
			let activeItem = document.getElementById('active-item');
			gsap.to(activeItem, {
				duration: 0.6,
				y: slideIndex * 50,
				ease: 'back.out(1.4)',
			});
		}
		historyTimeline.addEventListener('click', function(e) {
			if (e.target && e.target.nodeName == 'LI' && !e.target.classList.contains('active')) {
				// Correct Item
				let item = e.target;
				let year = item.dataset.year;

				// Correspondant history list item by year
				let historyItem = document.querySelector('.history-item[data-year="' + year + '"]');

				// Index of selected history item in History List/Slider
				let index = Array.prototype.indexOf.call(historyItems, historyItem);

				// Slide to Item of Index
				goToHistoryItem(index);
			}
		});

		// Awards Slider
		let timeline = document.getElementById('timeline'),
			yearsNumbers = document.getElementById('years'),
			pagination = document.getElementById('pagination'),
			paginationItems = pagination.getElementsByTagName('li');
		let timelineSlider = new Swiper(timeline, {
			slidesPerView: 1,
			mousewheel: true,
			spaceBetween: 20,
			grabCursor: true,
			freeMode: true,
			slideToClickedSlide: true,
			width: 340,
			breakpoints: {
				// when window width is >= 320px
				768: {
					slidesPerView: 'auto',
					spaceBetween: 126,
				},
			},
			on: {
				touchStart: function(ev) {
					ev.target.classList.add('touch');
				},
				touchEnd: function(ev) {
					ev.target.classList.remove('touch');
				},
				slideChange: function() {
					let activeSlider = timelineSlider.slides[timelineSlider.activeIndex],
						activeSliderYear = activeSlider.dataset.year,
						timelineYears = document.getElementsByClassName('timeline-year'),
						timelineActiveYear = document.querySelector(
							'.timeline-year[data-timeline-year="' + activeSliderYear + '"]',
						);

					console.log({
						activeSlider: activeSlider,
						activeSliderYear: activeSliderYear,
						timelineActiveYear: timelineActiveYear,
					});

					// Remove all active classes from timeline years
					for (let index = 0; index < timelineYears.length; index++) {
						const year = timelineYears[index];
						if (year.classList.contains('active')) {
							year.classList.remove('active');
						}
					}

					let activeYearTransform = timelineActiveYear.getBoundingClientRect().left;
					console.log(activeYearTransform);

					gsap.to(yearsNumbers, {
						duration: 2.5,
						ease: 'power4.inOut',
						x: -activeYearTransform,
						onStart: () => {
							timelineActiveYear.classList.add('active');
						},
					});
				},
			},
		});

		// Handle pagination clicks
		for (let index = 0; index < paginationItems.length; index++) {
			const paginationYear = paginationItems[index];
			paginationYear.addEventListener('click', function() {
				let targetYear = document.querySelector(
					'.timeline__card[data-year="' + paginationYear.dataset.year + '"',
				).dataset.index;

				timelineSlider.slideTo(targetYear, 1000);
			});
		}

		// Give the timeline a padding that equals container margin
		window.onload = function() {
			requestAnimationFrame(function() {
				timeline.style.paddingLeft =
					timeline.previousElementSibling.getElementsByTagName('h3')[0].getBoundingClientRect().left + 'px';
			});
		};
	}

	onLeave() {
		super.onLeave();
	}

	onEnterCompleted() {
		super.onEnterCompleted();
	}
}

export default about;



// WEBPACK FOOTER //
// ./scripts/highway/renderers/about.js